import { TFunction } from 'i18next';
import { TabBarItem } from '@lib/components/TabBar/constants';

type Args = {
  t: TFunction<'translation', undefined>;
  isAssetsAvailable: boolean;
  isSitesAvailable: boolean;
  isTasksAvailable: boolean;
  areasCount?: number;
  equipmentCount?: number;
  formTemplatesCount?: number;
  tasksCount?: number;
};

export default function getOperationalScopeTabs({
  t,
  isAssetsAvailable,
  isSitesAvailable,
  isTasksAvailable,
  areasCount,
  equipmentCount,
  formTemplatesCount,
  tasksCount,
}: Args): TabBarItem[] {
  const tabs: TabBarItem[] = [];
  if (isAssetsAvailable) {
    tabs.push({
      label: t('asset'),
      value: 'equipment',
      counter: equipmentCount,
    });
  }
  // Areas live under SitesManagement (see getSitesNavItem.ts → sites.areas).
  if (isSitesAvailable) {
    tabs.push({
      label: t('areas'),
      value: 'areas',
      counter: areasCount,
    });
  }
  if (isTasksAvailable) {
    tabs.push({
      label: t('form-templates'),
      value: 'formTemplates',
      counter: formTemplatesCount,
    });
    tabs.push({
      label: t('tasks'),
      value: 'tasks',
      counter: tasksCount,
    });
  }
  return tabs;
}
